import { Colors } from '@vetahealth/fishing-gear/colors'
import styled from 'styled-components/native'
import { Text } from '../Text'

type ToggleWrapperProps = {
  isChecked?: boolean
  isDisabled?: boolean
  isHovered?: boolean
}

export const ToggleWrapper = styled.View<ToggleWrapperProps>`
  width: 20px;
  height: 20px;
  border-width: 2px;
  border-color: ${({ isChecked = false, isHovered, theme }) =>
    isChecked ? theme.colors.primary : isHovered ? Colors.mauve500 : Colors.gray500};
  align-items: center;
  justify-content: center;
  border-radius: ${({ theme }) => theme.borderRadius.large}px;
`
export const Toggle = styled.View<{ isChecked?: boolean; isDisabled?: boolean }>`
  height: 11px;
  width: 11px;
  background-color: ${({ isChecked, theme }) => (isChecked ? theme.colors.primary : 'transparent')};
  border-radius: ${({ theme }) => theme.borderRadius.large}px;
`
export const LabelWrapper = styled.View``
export const Label = styled(Text).attrs(({ theme }) => ({
  weight: 'semiBold',
  size: 'toggle',
  color: theme.colors.toggleText,
}))``
